import _default from './Comment';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/views/Comment/index.js
// module id = 2760
// module chunks = 1